// extracted by mini-css-extract-plugin
module.exports = {"container":"benefitHeading-module--container--2Y4mQ"};